import type { RespiAllerReferralData } from '@common/validation/customControls/allergology/respiAllerReferral/v1/respiAllerReferralSchemaV1';
import { processActivityAnamnesisInitialData } from '@common/validation/customControls/processActivityAnamnesisData';
import { processActivityInitialMedicationData } from '@common/validation/customControls/processActivityMedicationData';
import { processActivityInitialProfessionalSummaryData } from '@common/validation/customControls/processActivityProfessionalSummaryData';

export const initialData: RespiAllerReferralData = {
    anamnesis: { ...processActivityAnamnesisInitialData },
    draftCareProviderOrganizationId: null,
    draftCareProviderPractitionerId: null,
    isPatientInformed: false,
    patient: { emailAddress: null, homePhoneNumber: null, mobileNumber: null },
    referralQuestion: null,
    ...processActivityInitialProfessionalSummaryData,
    ...processActivityInitialMedicationData,
};
